module.exports = __webpack_public_path__ + "static/roboto-latin-100.8ce59883.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-100.woff2
// module id = ./node_modules/typeface-roboto/files/roboto-latin-100.woff2
// module chunks = 0